export const initialAppointmentForm = {
  customBooking: 0,
  usersAvailabilityId: null,
  clientsEventId: '-1',
  from: null,
  duration: 60,
  stylistId: '-1',
  appointmentType: '-1',
  conciergeOption: 'SoHo Flagship',
  dressType: '-1',
  status: 'Pending',
  assignedPerson: '-1',
  errors: {
    clientsEventId: false,
    usersAvailabilityId: false,
    appointmentType: false,
    conciergeOption: false,
    dressType: false,
  },
};
